import { createContext } from 'react';

const UserContext = createContext({
  uuid: '',
});

export default UserContext;
